import React from 'react';

const headingColor = 'var(--color-secondary)';

export const H1 = ({ children }) => (
	<h1
		className="mt-12 mb-6 text-3xl sm:text-4xl text-left"
		style={{ color: headingColor }}
	>
		{children}
	</h1>
);

export const H2 = ({ children }) => (
	<h2
		className="mt-12 mb-6 text-2xl sm:text-3xl text-left"
		style={{ color: headingColor }}
	>
		{children}
	</h2>
);

export const H3 = ({ children }) => (
	<h3
		className="mt-12 mb-6 text-xl sm:text-2xl text-left"
		style={{ color: headingColor }}
	>
		{children}
	</h3>
);

export const H4 = ({ children }) => (
	<h4
		className="mt-12 mb-6 text-lg sm:text-xl text-left"
		style={{ color: headingColor }}
	>
		{children}
	</h4>
);

export const H5 = ({ children }) => (
	<h5
		className="mt-12 mb-6 text-base sm:text-lg text-left"
		style={{ color: headingColor }}
	>
		{children}
	</h5>
);

export const H6 = ({ children }) => (
	<h6
		className="mt-12 mb-6 text-sm sm:text-base text-left"
		style={{ color: headingColor }}
	>
		{children}
	</h6>
);

export const Paragraph = ({ children }) => (
	<p className="mb-6 text-sm sm:text-base text-left">{children}</p>
);

export const Em = ({ children }) => (
	<em className="mb-6 text-sm sm:text-base text-left">{children}</em>
);

// export const Divider = styled.hr`
//   text-align: center;
//   width: 240px;
//   margin: 4em auto;
//   border: 0px solid ${colors.lightOrange};
//   background-color: ${colors.lightOrange};
// `

// export const OrderedList = styled.ol`
//   list-style: inside;
//   list-style-type: decimal-leading-zero;
//   line-height: 1.8em;
//   max-width: 660px;
//   padding-left: 1em;
//   margin: 0.8em auto;
//   li {
//     margin-bottom: 0.25em;
//   }
// `

// export const UnorderedList = styled.ul`
//   display: grid;
//   grid-gap: 0.6em;
//   list-style: inside;
//   list-style-image: url(icons/radiobtn.svg);
//   line-height: 1.8em;
//   max-width: 660px;
//   padding-left: 1em;
//   margin: 0.8em auto;
//   li {
//     margin-bottom: 0.25em;
//   }
// `

// export const Blockquote = styled.blockquote`
//   text-align: center;
//   & > p {
//     max-width: 620px;
//     text-align: center;
//     margin: 0.8em auto;
//     font-size: 1.7em;
//     line-height: 1.4em;
//     display: inline-block;
//   }
//   & ::before,
//   & ::after {
//     content: '';
//     display: block;
//     margin: 0 auto;
//     width: 3em;
//     border-top: 2px solid rgba(0, 0, 0, 0.1);
//   }
//   padding: 0.8em 0em;
// `

// export const Center = styled.p`
//   text-align: center;
//   max-width: 660px;
//   margin: 30px auto;
//   h1,
//   h2,
//   h3,
//   h4,
//   h5,
//   p {
//     text-align: center;
//   }
// `

// export const Subtext = styled.p`
//   text-align: ${props => props.center ? 'center' : 'left'};
//   max-width: 660px;
//   margin: 0 auto;
//   line-height: 1.6em;
//   font-size: 0.8em;
//   margin-top: 0.8em;
// `

// export const SmallCenter = props => {
//   return (
//     <div
//       css={css({
//         [bpMinMD]: { maxWidth: '70%' },
//         maxWidth: '100%',
//         margin: '0 auto',
//         'h1, h2, h3, h4, h5, h6, p': {
//           textAlign: 'center',
//         },
//       })}
//     >
//       {props.children}
//     </div>
//   )
// }

// export const TwoParagraph = props => {
//   return (
//     <div
//       css={css({
//         display: 'grid',
//         gridGap: '2em',
//         margin: '0 auto',
//         gridTemplateColumns: '1fr',
//         [bpMinSM]: { gridTemplateColumns: '1fr 1fr' },
//         marginTop: '2em',
//         marginBottom: '4em',
//         maxWidth: '80%',
//       })}
//     >
//       {props.children}
//     </div>
//   )
// }
